import { render, staticRenderFns } from "./addExchangeOrder.vue?vue&type=template&id=13f2ece8&scoped=true"
import script from "./addExchangeOrder.vue?vue&type=script&lang=js"
export * from "./addExchangeOrder.vue?vue&type=script&lang=js"
import style0 from "./addExchangeOrder.vue?vue&type=style&index=0&id=13f2ece8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f2ece8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13f2ece8')) {
      api.createRecord('13f2ece8', component.options)
    } else {
      api.reload('13f2ece8', component.options)
    }
    module.hot.accept("./addExchangeOrder.vue?vue&type=template&id=13f2ece8&scoped=true", function () {
      api.rerender('13f2ece8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/purchasingManagement/exchange/addExchangeOrder.vue"
export default component.exports